// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"756ec3100d7d59de71df","223":"0aa0850d3a08373a02b4","293":"661d2c1b2db83c2c6297","522":"4cafe5be9b929f3a24b0"}[chunkId] + ".js";
};